export default function Crown({ className = "", strokeWidth = 2.5 }) {
  return (
    <svg viewBox="0 0 64 48" fill="none" className={className} aria-hidden="true">
      <path
        d="M4 40 L10 12 L22 26 L32 4 L42 26 L54 12 L60 40 Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path d="M8 44 H56" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
      <circle cx="32" cy="4" r="2.4" fill="currentColor" />
      <circle cx="10" cy="12" r="2" fill="currentColor" />
      <circle cx="54" cy="12" r="2" fill="currentColor" />
    </svg>
  );
}
